import recommendations from './recommendations.json';

interface RecommendationSet {
  recommendationNumber: string;
  description: string;
  actionSteps: string[];
}

interface RecommendationData {
  domain: string;
  subdomain: string;
  score: string;
  phaseTransition?: string;
  recommendationSets: RecommendationSet[];
}

type RecommendationsType = Record<string, Record<string, Record<string, Record<string, Record<string, string[]>>>>>;

export const getRecommendations = (
  domainName: string,
  subdomainName: string,
  score: string
): RecommendationData | null => {
  try {

    const recommendationsData = recommendations as unknown as RecommendationsType;
    const domainData = recommendationsData[domainName];
    if (!domainData) return null;


    const subdomainData = domainData[subdomainName];
    if (!subdomainData) return null;


    const scoreData = subdomainData[score];
    if (!scoreData) return null;

    const recommendationSets: RecommendationSet[] = [];
    let firstPhaseTransition = '';


    Object.entries(scoreData).forEach(([currentPhaseTransition, recommendations]) => {
      if (!firstPhaseTransition) {
        firstPhaseTransition = currentPhaseTransition;
      }
      
      // Iterate through recommendation sets
      Object.entries(recommendations as Record<string, string[]>).forEach(([recNumber, recDetails]) => {
        if (recDetails && recDetails.length > 0) {
          recommendationSets.push({
            recommendationNumber: recNumber,
            description: recDetails[0] || '',
            actionSteps: recDetails.slice(1) || []
          });
        }
      });
    });

    return {
      domain: domainName,
      subdomain: subdomainName,
      score: score,
      phaseTransition: firstPhaseTransition,
      recommendationSets
    };
  } catch (error) {
    console.error('Error getting recommendations:', error);
    return null;
  }
};